import { supabase } from '@/integrations/supabase/client';

const handleRolloverError = (error: any, operation: string) => {
  console.error(`[Rollover Service] ${operation} failed:`, error);
  
  // Map common errors
  if (error.code === 'PGRST116') {
    throw new Error('Rollover operation not found');
  }
  if (error.code === '42501') {
    throw new Error('Insufficient permissions to perform rollover');
  }
  
  throw new Error(error.message || `Failed to ${operation}`);
};

export interface RolloverResult {
  processed_count: number;
  rollover_year: number;
  target_year: number;
  company_id: string;
}

export const rolloverService = {
  // NOTE: annual rollover execution is service-role only (scheduled job
  // `process-annual-rollover`). It is intentionally NOT callable from the client.

  /**
   * Validate leave request against policy rules (read-only validation)
   */
  async validateLeaveRequest(
    profileId: string,
    leaveType: string,
    startDate: string,
    endDate: string,
    requestedDays?: number
  ) {
    try {
      console.log('[rolloverService] Validating leave request:', {
        profileId,
        leaveType,
        startDate,
        endDate,
        requestedDays
      });

      const { data, error } = await supabase.rpc('validate_leave_request_against_policy', {
        p_profile_id: profileId,
        p_leave_type: leaveType,
        p_start_date: startDate,
        p_end_date: endDate,
        p_requested_days: requestedDays || null
      });

      if (error) {
        console.error('[rolloverService] Validation error:', error);
        throw error;
      }

      console.log('[rolloverService] Validation result:', data);
      return data;
    } catch (error) {
      handleRolloverError(error, 'validate leave request');
      throw error;
    }
  }
};